import noop from 'lodash/noop';
import { createActions } from 'redux-actions';
export const jabraActions = createActions({
    JABRA_LIST: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    JABRA_RING: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    JABRA_UNRING: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    JABRA_INIT: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
}, 'JABRA_INIT_SUCCEEDED', 'JABRA_ATTACHED', 'JABRA_DETACHED', 'JABRA_RING_SUCCEEDED', 'JABRA_RING_FAILED', 'JABRA_UNRING_SUCCEEDED', 'JABRA_UNRING_FAILED', 'JABRA_LIST_SUCCEEDED', 'JABRA_LIST_FAILED', 'JABRA_CLOSED', 'JABRA_BUTTON_CLICKED', 'JABRA_BUTTON_CLICKED_ACCEEPTED_CALL_OFFER_CONVERSATION', 'JABRA_BUTTON_CLICKED_REJECTED_CALL_OFFER_CONVERSATION', 'JABRA_BUTTON_CLICKED_UNSUPPORTED');
